import Immutable from 'seamless-immutable';
import { createReducer, completeReducer, completeState, onReadValue, onConcatenate } from 'redux-recompose';

import { ORDER_STATUS } from '~constants/orders';

import { updateOrderByPusher, addOrderToPrintQueue, removeOrderPrintQueue } from './effects';
import { actions } from './actions';

const stateDescription = {
  orders: {
    list: null,
    currentPage: 0,
    nextPage: 0,
    previousPage: 0,
    totalPages: 0,
    totalCount: 0
  },
  ordersFilter: [ORDER_STATUS.CREATED],
  peyaCancelledOrder: null,
  newOrders: [],
  quantityOrders: {},
  updateOrderDeliveryType: null,
  print: [],
  printedOrderIds: [],
  orderToPrint: null,
  orderIdStack: []
};

const initialState = completeState(stateDescription);

const reducerDescription = {
  primaryActions: [
    actions.GET_ORDERS,
    actions.UPDATE_ORDER,
    actions.GET_PEYA_CANCELLED_ORDER,
    actions.GET_QUANTITY_ORDERS,
    actions.UPDATE_ORDER_DELIVERY_TYPE,
    actions.CHECK_PENDING_ORDERS,
    actions.ADD_ORDER_TO_QUEUE,
    actions.GET_ORDER_TO_PRINT
  ],
  override: {
    [actions.SET_ORDERS_FILTER]: onReadValue(),
    [actions.SET_ACTIVE_TAB]: onReadValue(),
    [actions.SET_NEW_ORDERS]: onReadValue(),
    [actions.SET_CANCELLING_ORDER]: onReadValue(),
    [actions.SET_NULL_PEYA_CANCELLED_ORDER]: onReadValue(),
    [actions.UPDATE_ORDER_BY_PUSHER]: updateOrderByPusher,
    [actions.UPDATE_ORDER_FROM_LIST]: (state, action) =>
      state.merge({
        ...state,
        orders: { ...state.orders, list: action.payload.newList }
      }),
    [actions.PRINT]: addOrderToPrintQueue,
    [actions.REMOVE_PRINT_QUEUE]: removeOrderPrintQueue,
    [actions.ADD_ORDER_ID_TO_STACK]: onConcatenate(),
    [actions.REMOVE_ORDER_ID_FROM_STACK]: (state, action) => {
      const stack = state.orderIdStack;
      return state.merge({
        ...state,
        orderIdStack: stack.filter((id) => id !== action.payload)
      });
    },
    [actions.RESET_ORDER_ID_STACK]: (state) => state.merge({ ...state, orderIdStack: [] })
  }
};

export default createReducer(new Immutable(initialState), completeReducer(reducerDescription));
